export const getAge = (dateString) => {
    const birthDate = new Date(dateString);
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();

    // Если текущий месяц меньше месяца рождения, или если это тот же месяц, но день ещё не наступил, уменьшить возраст на 1
    if (monthDifference < 0 || (monthDifference == 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }

    return age;
}

export const getDateFromISOString = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleDateString('uk-UA', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    });
}